<template>
  <el-menu
      :default-active="defaultTab"
      class="el-menu-vertical-demo"
      @select="onType">
      <el-menu-item :index="item.key"
      v-for="item in types"
      v-if="item.isShow"
      :key="item.key"
      >
        <span slot="title">{{ item.name }}</span>
      </el-menu-item>
  </el-menu>
</template>

<script>
export default {
  props: {
    onType: {
      type: Function
    },
    types: Array,
    defaultTab: String
  },
  data() {
    return {
    }
  }
}
</script>
<style lang='scss' scoped>
.el-menu-item {
  &.is-active {
    background: #409eff;
    i,
    span {
      color: #fff;
    }
  }
}
</style>
